import { Link, useLocation } from 'react-router-dom';

interface BoardSidebarProps {
  boardId: string;
}

export function BoardSidebar({ boardId }: BoardSidebarProps) {
  const location = useLocation();

  const menuItems = [
    { id: 'epics', label: 'Epics', icon: '📋', path: `/boards/${boardId}/epics` },
    { id: 'wikis', label: 'Wikis', icon: '📚', path: `/boards/${boardId}/wikis` },
    { id: 'history', label: 'History', icon: '📜', path: `/boards/${boardId}/history` },
  ];

  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-40">
      <div className="flex flex-col gap-2">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`
                flex items-center gap-3 px-4 py-3 rounded-l-lg transition-all duration-200
                ${
                  isActive
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-white'
                }
              `}
            >
              <span className="text-xl">{item.icon}</span>
              <span className="font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
